import mustache from 'mustache';
import { Trip_v2 } from "../util/tripPlanner_types";
import { get_wishesToken, getTripHTML, send_updateTripWishes } from "./api_utils";
import { genie_wishes_added_disp, genie_wishes_result, genie_wishes_result_no_add, wishes_result_list_item } from './templates';
import { display_trip_html, init_remWishes_listener } from './tripPlanner_scripts';
import { get_stop_from_stopID, handle_auto_lock } from './util/helper_functions';
import { places_search } from '../util/general_util';

export async function handle_addWishes_click() {
    const addWishesEl:JQuery<HTMLElement> = $(this);

    const stopID = addWishesEl.attr("stopID");
    let stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
    if (stopData == null) return;
    let stop = stopData.stop;
    let legIndex = stopData.legIndex;
    let stopIndex = stopData.stopIndex;

    if (! stop.fromUserQuery) {
        stopData = await handle_auto_lock(stopData);
        if (stopData == null) return;
        stop = stopData.stop;
        legIndex = stopData.legIndex;
        stopIndex = stopData.stopIndex;
    };

    const wrapper:JQuery<HTMLElement> = addWishesEl.closest("[stopWishesWrapper]");
    if (wrapper.length == 0) return;
    wrapper.find("[stopWishes_list]").find("[rem-li]").remove();
    const stopWishes_list = wrapper.find("[stopWishes_list]")

    const wishes_items =stopWishes_list.find("li").map(function(idx,el) {return el.innerHTML}).toArray();

    if (stop.wishes) {
        stop.wishes.push(...wishes_items);
    } else {
        stop.wishes = [...wishes_items];
    };

    $(mustache.render(genie_wishes_added_disp,{})).insertAfter(addWishesEl);
    addWishesEl.remove();

    init_remWishes_listener();

    await send_updateTripWishes([{
        legIndex: legIndex,
        stopIndex: stopIndex,
        wishes: stop.wishes
    }]);

    // display_wishes_stopPopout(stop);

    const tripHTML = await getTripHTML(window.tripPlannerCurrentTrip);
    window.tripPlannerCurrentTrip.stopListHTML = tripHTML;
    display_trip_html(window.tripPlannerCurrentTrip, true);

};

export const getTripTips = async (trip:Trip_v2, outputSelector:string, tripStops:Array<{title:string,stopID:string,coords:{latitude:number,longitude:number}}>, userInterests_resp:string, whatToDo_resp:string, is_suggested_stop:boolean):Promise<void>  => {
    const outputEl:JQuery<HTMLElement> = $(outputSelector);


    const tripStopStrings:string = JSON.stringify(tripStops.map(stop => {return stop.title}));


    outputEl.html("");

    return new Promise<void>((resolve,reject) => {

        get_wishesToken().then(apiToken => {
            const source = new EventSource(`/tips?token=${apiToken}&tripStops=${encodeURIComponent(tripStopStrings)}&userInterests_resp=${encodeURIComponent(userInterests_resp)}&whatToDo_resp=${encodeURIComponent(whatToDo_resp)}`);
            let buffer: string = "";
	        let responseFull: string = "";

            outputEl.html("");
            let stopsReceived = 0;

            source.onmessage = function (event) {
                responseFull += event.data;
                buffer += event.data;
                const jsonMatches = buffer.match(/\{[^{}]*\}/g);
                // const jsonMatches = buffer.match(/\{"title":.*,\s*"itinerary":\[.*\]\}/g);

                if (jsonMatches) {
                    jsonMatches.forEach(jsonStr => {
                        try {
                            const data = JSON.parse(jsonStr);

                            const stop = tripStops[stopsReceived];
                            let stopHTML;
                            if (is_suggested_stop) {
                                stopHTML = $(mustache.render(genie_wishes_result_no_add, { stopTitle: data.title, stopID: stop.stopID }));
                            } else {
                                stopHTML = $(mustache.render(genie_wishes_result, { stopTitle: data.title, stopID: stop.stopID }));
                            }
                            // const stopHTML = $(mustache.render(genie_wishes_result, { stopTitle: data.title, stopID: stop.stopID }));
                            for (let i = 0; i < data.itinerary.length; i++) {
                                 stopHTML.find("ul").append(mustache.render(wishes_result_list_item, { itinerary_item: data.itinerary[i] }));
                                // const itinerary_data = data.itinerary[i];
                                // const itinerary_element = $(mustache.render(wishes_result_list_item, { itinerary_item: itinerary_data.itinerary }));

                                // stopHTML.find("ul").append(itinerary_element);

                                // places_search(`${itinerary_data.location} - ${data.title}`, stop.coords).then(result => {
                                //     if (!result.places || result.places.length < 1) return;
                                //     const itinerary_element_text = itinerary_element.find('[itinerary-text]');

                                //     if (result.places[0].websiteUri) {
                                //         itinerary_element_text.html(`<a target="_blank" href="${result.places[0].websiteUri}">${itinerary_element_text.html()}</a>`);
                                //     } else if (result.places[0].googleMapsUri) {
                                //         itinerary_element_text.html(`<a target="_blank" href="${result.places[0].googleMapsUri}">${itinerary_element_text.html()}</a>`);
                                //     };
                                // });
                            }
                            outputEl.append(stopHTML);

                            stopsReceived += 1;
                        } catch (e) {
                            console.error("Parsing error:", e);
                        }
                    });

                    // Remove the matched JSON strings from the buffer
                    const lastMatchEnd = buffer.lastIndexOf(jsonMatches[jsonMatches.length - 1]) + jsonMatches[jsonMatches.length - 1].length;
                    buffer = buffer.slice(lastMatchEnd);  // Keep only the remaining part after the last complete JSON
                }
            };

            source.onerror = function (error) {
                reject(error);
            };

            source.addEventListener("end", function (e) {
                source.close();

                $("[addWishes]").off("click");
                $("[addWishes]").on("click", handle_addWishes_click);
                resolve();
            });
        }).catch(e => {
            reject(new Error(e.responseText));
        });
    });
};